export default "__VITE_ASSET__CU0Is9Yn__"